<m27-main-menu [appTitle]="'Gatekeeper'" [isAuthenticated]="isLoggedIn" [firstName]="loggedInUserDisplayName" [headshot]="loggedInUserAvatar" (logout)="logout()">
    <div class="menu-item" [routerLink]="'/home'" routerLinkActive="active" style="margin-left: 11px;">
        <i class="icon home" style="font-size: 20px !important; position: relative; top: -4px !important;"></i>
    </div>
    <div *ngIf="userAccess.CanDoPermits.Value()" class="menu-item" [routerLink]="'/permitting'" routerLinkActive="active">Permitting</div>
    <div *ngIf="userAccess.CanDoReports.Value()" class="menu-item" [routerLink]="'/reporting'" routerLinkActive="active">Reporting<div automationid="mainMenuUnreadReportCount" class="badge round success" title="unviewed reports" *ngIf="GetUnreadReportCount() > 0">{{GetUnreadReportCount()}}</div></div>

    <!--<m27-global-search-tips>
        <div class="section-title">Search Tips:</div>
        <div class="summary">In this section you can provide your users information on how to search.</div>
        <div class="summary">For this demo app, if you search on "grid results" it will show you an example of having your results in a data grid.  Anything else will just show an html result example.</div>
    </m27-global-search-tips>-->
    <!--<m27-global-search-results>
        <div class="section-title">Search Results:  <span>{{searchPhrase}}</span></div>
        <p>In this section you can provide your users information on what was searched.</p>
        <p>This is just a blank template.</p>
        <div *ngFor="let s of searchResults">
            {{s}}
        </div>
    </m27-global-search-results>-->
    <m27-global-user-info *ngIf="isLoggedIn" #userInfo>
        <!--<img [src]="loggedInUserAvatar" style="max-width: 48px; max-height: 48px;" />-->
        <div>
            <div style="float: left; margin-bottom: 20px;">
                <div style="font-size: 15pt;">
                    {{ loggedInUserFirstName }}&nbsp;{{ loggedInUserLastName }}
                </div>
                <div style="font-size: 10pt; color: #0166b7; padding-left: 2px;">
                    {{ loggedInUserEmail }}
                </div>
                <div style="font-size: 9pt; color: rgba(0,0,0,.5); margin-top: 4px;padding-left: 2px;">
                    {{ loggedInUserPhone }}
                </div>
            </div>
            <div class="close-button" (click)="userInfo.hide()" style="float: right;
                                                                        font-size: 14pt;
                                                                        margin-right: 2px;
                                                                        opacity: .8;">
                <i class="icon close-squared"></i>
            </div>
        </div>
        <br/>
        <m27-page-section [caption]="'Roles'">
            <ul style="margin-block-start: 0px; padding-inline-start: 30px; font-size: 13px;">
                <li *ngFor="let role of loggedInUserRoles">
                    {{role}}
                </li>
            </ul>
        </m27-page-section>
    </m27-global-user-info>
</m27-main-menu>
<router-outlet></router-outlet>
<m27-footer [environment]="runEnvironment" [version]="version" [copyright]="copyright" [message]="'Internal Use Only'"></m27-footer>
<m27-dialogs></m27-dialogs>
<app-dialogs></app-dialogs>
